/* eslint-disable */

import "core-js/stable";
export function isObject(node) {
  return typeof node === "object" && node !== null;
}
export default function extractFiles(tree, treePath) {
  if (treePath === void 0) {
    treePath = "";
  }

  var files = [];

  function recurse(node, nodePath) {
    Object.keys(node).forEach(function (key) {
      if (!isObject(node[key])) {
        return;
      }
      var path = "" + nodePath + key;

      if (
        (typeof File !== "undefined" && node[key] instanceof File) ||
        (typeof Blob !== "undefined" && node[key] instanceof Blob) ||
        node[key] instanceof ReactNativeFile
      ) {
        files.push({
          path: path,
          file: node[key],
        });
        node[key] = path;
        return;
      }

      if (typeof FileList !== "undefined" && node[key] instanceof FileList)
        node[key] = Array.prototype.slice.call(node[key]);
      recurse(node[key], path + ".");
    });
  }

  if (isObject(tree)) {
    recurse(tree, treePath === "" ? treePath : treePath + ".");
  }
  return files;
}
export function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    type = _ref.type,
    name = _ref.name;
  this.uri = uri;
  this.type = type;
  this.name = name;
}

ReactNativeFile.list = function (files) {
  return files.map(function (file) {
    return new ReactNativeFile(file);
  });
};
